


































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import symbol from "./symbol";
import ChangeEditSubVue from "./ChangeEditSub.vue";

@Component({
    components: {
        "changeEdit-dialog": ChangeEditSubVue,
    },
    ...mapGetters(["accountBook"])
})
export default class EditSub extends Vue {
    @Prop({ type: Object })
    editSubjectForm?: EditSubject;

    @Prop({ type: Array })
    types?: string[];

    @Prop({ type: Object })
    row?: Subject.Subject;

    symbolSelect: string[] = symbol.list
    checkType: string[] = [];
    assists: string[] = ["项目", "客户", "供应商", "部门", "员工", "存货"];
    mounted() {
        if (this.types) {
            this.checkType = this.types
        }

    }

    // 编辑取消
    close() {
        this.$emit("close")
    }
    //编辑科目，点击确定按钮
    confirmEdit() {
        if (this.editSubjectForm) {
            if (this.editSubjectForm.toSelectAss && this.checkType.length > 0) {
                this.saveType = 3;
                this.showChangeEdit = true;
            } else {
                this.saveType = 4;
                this.updateEdit(false);
            }
        }
    }

    tranAss: Assist.Relation | {} = {};
    transRelation(val: string) {
        switch (val) {
            case "项目":
                return "dimItemId";
            case "客户":
                return "dimCustomerId";
            case "部门":
                return "dimDepartmentId";
            case "员工":
                return "dimEmployeeId";
            case "存货":
                return "dimInventoryId";
            case "供应商":
                return "dimProviderId";
            default:
                return "dimItemId";
        }
    }
    getRelation() {
        let obj = {};
        this.checkType.forEach((v: string, i: number) => {
            let attr = this.transRelation(v);
            // @ts-ignore
            obj[attr] = this.tranAss[v].id;
        });
        return obj;
    }
    // 编辑科目请求接口
    updateEdit(isTrans: boolean) {
        let _this = this;
        if (this.editSubjectForm) {
            Vue.axios
                .post(`subjects/` + this.editSubjectForm.id + `/modify`, {
                    no: this.editSubjectForm.subjectCode,
                    text: this.editSubjectForm.subjectName,
                    measuringUnit: this.editSubjectForm.measuringUnit,
                    currSymbol: this.editSubjectForm.currSymbol,
                    dimAccountTypes: this.checkType,
                    relation: isTrans ? this.getRelation() : null
                })
                .then(res => {
                    this.$emit("success", true)
                });
        }
    }

    //  新增点击保存
    saveType: number | null = null
    saveAndExit(bool: boolean) {
        bool ? (this.saveType = 1) : (this.saveType = 2);
        if (this.editSubjectForm && this.checkType && this.row) {
            let name: string = this.editSubjectForm.parentSubjectName;
            let code: string = this.editSubjectForm.parentSubjectCode;
            if (this.editSubjectForm.subjectName === "") {
                this.editSubjectForm.showTip = true;
            } else if (
                this.editSubjectForm.toSelectAss &&
                this.checkType.length > 0 &&
                this.row.dimAccountType === null
            ) {
                this.showChangeEdit = true;
            } else {
                this.editSubjectForm.showTip = false;
                this.updateItem(false, (res: any) => {
                    if (bool) {
                        this.$emit("close")
                    } else {
                        if (this.editSubjectForm && this.row) {
                            this.editSubjectForm.assistDisabled = false;
                            this.editSubjectForm.dimAccountType = null;
                            this.editSubjectForm.subjectName = ""
                            Vue.axios
                                .get(`subjects/` + this.row.id + `/createno`)
                                .then(res => {
                                    if (this.editSubjectForm && this.row) {
                                        this.editSubjectForm.subjectCode = res.data.no;
                                        if (this.row.no === res.data.no) {
                                            this.$alert(
                                                "亲，当前科目编码已达到最大值，请自定义编写编码",
                                                "温馨提示"
                                            )
                                        }
                                        this.$emit("success", false)
                                    }
                                });
                        }
                    }
                });
            }
        }
    }
    // 请求接口保存
    updateItem(isTrans: boolean, next: Function) {
        if (this.editSubjectForm) {
            Vue.axios
                .post(`subjects/` + this.editSubjectForm.id + `/savecreate`, {
                    no: this.editSubjectForm.subjectCode,
                    text: this.editSubjectForm.subjectName,
                    measuringUnit: this.editSubjectForm.measuringUnit,
                    currSymbol: this.editSubjectForm.currSymbol,
                    dimAccountTypes: this.checkType,
                    relation: isTrans ? this.getRelation() : null
                })
                .then(res => {
                    next(res);
                });
        }
    }

    // 是否展示选择辅助核算
    showChangeEdit: boolean = false
    changeEditClose(isEdit?: boolean) {
        if (isEdit) {
            if (this.editSubjectForm && this.row) {
                this.editSubjectForm.assistDisabled = false;
                this.editSubjectForm.dimAccountType = null;
                this.editSubjectForm.subjectName = ""
                Vue.axios
                    .get(`subjects/` + this.row.id + `/createno`)
                    .then(res => {
                        if (this.editSubjectForm && this.row) {
                            this.editSubjectForm.subjectCode = res.data.no;
                            this.$emit("success", false)
                        }

                    });
            }
        }
        else this.showChangeEdit = false
    }
    changeEditSuccess() {
        this.showChangeEdit = false;
        this.$emit("close")
    }

}
